import { apiClient } from '@/services'

import type {
  DecisionDecideInput,
  DecisionSupersedeInput,
  DecisionView,
} from '../types'

const base = (orgId: string, projectId: string): string =>
  `/${orgId}/projects/${projectId}/decisions`

const byRef = (orgId: string, projectId: string, decisionRef: string): string =>
  `${base(orgId, projectId)}/${encodeURIComponent(decisionRef)}`

/** The project-scoped decisions boundary; mutations always use the server's `ref`. */
export const decisionsService = {
  listDecisions(orgId: string, projectId: string): Promise<DecisionView[]> {
    return apiClient.get<DecisionView[]>(base(orgId, projectId))
  },

  decideDecision(
    orgId: string,
    projectId: string,
    decisionRef: string,
    input: DecisionDecideInput
  ): Promise<DecisionView> {
    return apiClient.post<DecisionView>(
      `${byRef(orgId, projectId, decisionRef)}/decide`,
      input
    )
  },

  supersedeDecision(
    orgId: string,
    projectId: string,
    decisionRef: string,
    input: DecisionSupersedeInput
  ): Promise<DecisionView> {
    return apiClient.post<DecisionView>(
      `${byRef(orgId, projectId, decisionRef)}/supersede`,
      input
    )
  },
}
